// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
// config
import { HEADER } from 'src/config';
import { AppGridContent } from 'src/components';

export const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: 'transparent',
  },
}));

export const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  height: HEADER.MOBILE_HEIGHT,
  [theme.breakpoints.up('lg')]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
  },
}));

export const SectionStyle = styled(AppGridContent)(({ theme }) => ({
  backgroundColor: theme.palette.branded.paper,
  '& .container': {
    maxWidth: 445,
    margin: 'auto',
    minHeight: '100vh',
    justifyContent: 'center',
    [theme.breakpoints.down("lg")]: {
      maxWidth: 360,
    }
  }
}));

export const ContentStyle = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isEmbedded',
})<{ isEmbedded?: boolean }>(({ theme, isEmbedded }) => ({
  maxWidth: 400,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(isEmbedded ? 0 : 2),
  '& .MuiLink-root': {
    fontSize: 14,
  },
}));
